import React, { useEffect, useState } from 'react';
import Axios from '../../lib/axios/axiosInstance';
import { Container, Row, Col } from 'react-bootstrap';

import './OurFeatures.styles.css';
// import Features from '../../mockups/headerFeatures.json';

const OurFeatures = () => {

  const [featureList, setFeatureList] = useState([]);

  const getFeatures = async () => {
    await Axios.get('/cms1/HHFeatures')
      .then(function (response) {
        if (response.data && response.data.data) {
          const responseData = response.data.data.HHFeatures;
          if (responseData.length > 0) {
            setFeatureList(responseData);
          }
          else {
            setFeatureList([]);
          }
        }
      })
      .catch(function (error) {
        setFeatureList([]);
      });
  };

  useEffect(() => {
    getFeatures();
  }, [])

  return (
    <div className="our-features-box hidden-xs">
      <Container fluid>
        <Row style={{ marginBottom: "20px" }}>
          {/* {featureList && featureList?.map(feature => (
            <Col xs={12} md={3} sm={6} key={feature.id}>

              <div className="feature-box first"> <i className={feature?.icon || "icon-plane icons"}></i>
                <div className="content">
                  <h3>{feature?.title || "Free & Next Day Delivery"}</h3>
                </div>
              </div>
            </Col>
          ))} */}
          <Col xs={12} md={4} sm={6} style={{ display: "flex", borderRight: "3px solid #e7eaec" }}>
            <div style={{ display: "20" }}> <img src="https://comoffice.sg/image/catalog/usp/icon_hp-usp-wide.png" alt="Widest Range Of Desktop To Pantry" class="img-responsive" />
            </div>
            <div style={{ display: "80", fontFamily: "'Josefin Sans', sans-serif", textTransform: "uppercase", fontWeight: "600", display: "flex", flexWrap: "wrap", alignContent: "center" }}>
              Widest Range Of Desktop To Pantry
            </div>
          </Col>
          <Col xs={12} md={4} sm={6} style={{ display: "flex", borderRight: "3px solid #e7eaec" }}>
            <div style={{ display: "20" }}> <img src="https://comoffice.sg/image/catalog/usp/icon_hp-usp-variety.png" alt="Widest Range Of Desktop To Pantry" class="img-responsive" />
            </div>
            <div style={{ display: "80", fontFamily: "'Josefin Sans', sans-serif", textTransform: "uppercase", fontWeight: "600", display: "flex", flexWrap: "wrap", alignContent: "center" }}>
              VARIETY, QUALITY & EFFICIENCY
            </div>
          </Col>
          <Col xs={12} md={4} sm={6} style={{ display: "flex", borderRight: "3px solid #e7eaec" }}>
            <div style={{ display: "20" }}> <img src="https://comoffice.sg/image/catalog/usp/icon_hp-usp-importer.png" alt="Widest Range Of Desktop To Pantry" class="img-responsive" />
            </div>
            <div style={{ display: "80", fontFamily: "'Josefin Sans', sans-serif", textTransform: "uppercase", fontWeight: "600", display: "flex", flexWrap: "wrap", alignContent: "center" }}>
              IMPORTER, EXPORTER, WHOLESELLER & RETAILER
            </div>
          </Col>
        </Row>
      </Container>
    </div >
  );
};

export default OurFeatures;
